const API_BASE = "/api/v1"

export interface KibbleTip {
  delivery_id: number
  tip_id: number
  title: string
  category: string | null
  why_it_matters: string | null
  how_to_do_it: string | null
  delivered_at: string
  opened_at: string | null
}

export interface KibblePerspective {
  delivery_id: number
  perspective_id: number
  dog_profile_id: number
  title: string | null
  body: string
  archetype_label: string | null
  delivered_at: string
  opened_at: string | null
}

export interface KibbleCurrentResponse {
  tip: KibbleTip | null
  perspective: KibblePerspective | null
}

export async function getKibbleCurrent(): Promise<KibbleCurrentResponse> {
  const res = await fetch(`${API_BASE}/kibble/current`, { credentials: "include" })
  if (!res.ok) throw new Error("Not authenticated")
  return res.json()
}

export async function markTipOpened(deliveryId: number): Promise<void> {
  const res = await fetch(`${API_BASE}/tip_deliveries/${deliveryId}/open`, {
    method: "PATCH",
    credentials: "include",
    headers: { Accept: "application/json" },
  })
  if (!res.ok) throw new Error("Could not mark tip as opened")
}

export async function markPerspectiveOpened(deliveryId: number): Promise<void> {
  const res = await fetch(`${API_BASE}/perspective_deliveries/${deliveryId}/open`, {
    method: "PATCH",
    credentials: "include",
    headers: { Accept: "application/json" },
  })
  if (!res.ok) throw new Error("Could not mark perspective as opened")
}

/** Split tip how-to text into bullet steps when formatted with • markers. */
export function parseTipSteps(howTo: string | null | undefined): string[] {
  if (!howTo?.trim()) return []
  return howTo
    .split(/\n+/)
    .map((line) => line.replace(/^[•-]\s*/, "").trim())
    .filter(Boolean)
}
